import { Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseForm } from '@components/base-form.abstract';

@Directive({ selector: 'app-filters, [appFilters]', exportAs: 'appFilters' })
export class FiltersDirective<T> extends BaseForm implements OnInit {
  @Input() override form: FormGroup;
  @Input() queryParams: T;
  @Output() queryParamsChange = new EventEmitter<T>();
  areAdditionalFiltersHidden = true;

  ngOnInit(): void {
    this.form.patchValue(this.queryParams);
  }

  clearFilters(
    value?: any,
    options?: {
      onlySelf?: boolean;
      emitEvent?: boolean;
    },
  ): void {
    this.form.reset(value, options);
    this.search();
  }

  onQueryParamsChange(v?: T): void {
    this.queryParams = { ...this.queryParams, ...v, page: 0 };
    this.queryParamsChange.emit(this.queryParams);
  }

  search(): void {
    this.onQueryParamsChange(this.form.getRawValue());
  }

  printToggleFiltersLabel(): string {
    return this.areAdditionalFiltersHidden ? $localize`Pokaż filtry` : $localize`Ukryj filtry`;
  }
}
